export interface DefaultPropsConfig {
  className?: string;
  style?: object;
  disable?: boolean;
  alt?: boolean;
  placeholder?: string;
}

export interface PositionConfig {
  x: number;
  y: number;
}
